import React from "react";
import PropTypes from "prop-types";
import propTypes from "@styled-system/prop-types";
import FormInput from "./formInput";
import FormPaymentInput from "./formPaymentInput";
import FormCheckbox from "./formCheckbox";
import FormRadio from "./formRadio";
import FormSelect from "./formSelect";
import FormTextArea from "./formTextArea";
import { FormStyle } from "./forms.style";

const Form = ({
  innerRef,
  ...props
}) => {
  return (
    <FormStyle {...props} ref={innerRef} />
  );
};

Form.propTypes = {
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  inline: PropTypes.bool,
  ...propTypes.space,
  ...propTypes.flexbox,
};

Form.defaultProps = {
  inline: false,
};

export {
  FormInput,
  FormPaymentInput,
  FormSelect,
  FormCheckbox,
  FormRadio,
  FormTextArea,
};

export default Form;
